import { constructionSafety, logisticsAsset, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '4차 산업혁명 시대에 IPS(Indoor Positioning System), 즉 실내 위치 추적 시스템은 기업과 조직이 밀폐된 공간 내에서 사람, 장비, 자산의 위치를 제어하는 데 핵심적인 솔루션으로 자리 잡았습니다. GPS가 실외에서만 작동하는 것과 달리, IPS는 Wi-Fi, BLE, UWB, RFID와 같은 기술을 활용해 공장, 쇼핑몰, 공항 등 복잡한 실내 환경에서 정확한 위치를 추적합니다. 이 글에서는 IPS가 무엇인지, 주요 기술, 이점, 그리고 디지털 전환에서의 역할을 자세히 알아보겠습니다.',
  keywords: 'IPS, Indoor Positioning System, 실내 위치 추적 시스템, 기업을 위한 IPS 솔루션',
  ogSite: 'IPS란 무엇인가요? 기술 분야에서 IPS의 역할은 무엇인가?',
  title: 'IPS란 무엇인가요? 기술 분야에서 IPS의 역할은 무엇인가?',
  ogUrl: 'https://orbro.io/blog/ips',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_G2fm8iqt4qLTYnN_aPOYkNbRT9IPNt4KtS6Xbd3EowiUER6gyqQKWZekogjnUS9dYgRsFyvKExf0euI0M_bGhsioLVbKJ0EGg2X69l2IoaQ1TIfybqO_RWv2sBXfmcUBNlJObHJJ-U1z24bLxxsGT-FPJOxqyqx_sWKRAB6xQT-pUcfaizd88gh8zGpT1dNgeRsy4TrqcIDfiSg0xfeaf45IQUrCLfnY1eDEMZdbZKgZ1WGsCSw6Jm6Ifeade_Q5fcHr6ysZHWmIKu0n7TO_N72h5AR1PkKYyfcCvBHFoVAkj9EGY5xDYT4E2CX_Fbsklo9Q6on9xq3JwnvtcoM-kHSQTNXQDlcRz38B9l3kxxoRZz7iOQUIbmaIwhCrtEZjCetLuzRHqvBTVw45hbSZ1Mra7TT2a85JysKnLqoX8idLhqMRKHo3cy9rcvjWlk6vZecYdfUl3dsaAW0tUyxNZfK6HoSK6dQsJsoLqIhKQHJb1NckTwEU3U7U5fLO8fUZr0X7dL-HFK7Wz39FVsyvX20P6il3uX8Jasbtie8EEtuiLzhLN_gjjxJdn9zZbjr3pQ1mAG0negaDof9P76xWrCtGqKkbNKI-PCpXZkUpuTfxWkLuxY53D5twVA0kQ2RArKGMzQuxD7IZFpgA7KLIUWzLl9FIDPvaRMAP5iHll-Ae9h89R7REL2NlU72DOISXfRS1qF88bPD-AdnHnAPBgorxDyUo_1V_T54O8EuC-yU52v3KNIogHmhrmOkrwVOAnwsm0ypC25VAXORgVP-wNYNJURc34_3JabyVNrqT7ZFLcmxjqoId3TpQeFWawPmV9HcUdhIs15phRDJKzON16uh8OBF1sskw57RoNFMy5mhfmLKy-i0BIK3Aiy2K3tmTA5aPpUsTyrJvCivlY4Z5IJVUkjYIO_XH-viCbD3GjKB_6CJO8IhOxkTiWWfDu_bPuVCODtc1yKLK1L3YvoGy9eTNA3WnQonWU6DP8kVz0dBwgHD2wA_8bYr8GYUDpglrGaecLgKOsTd3jZ7-ecr9lZmYPtUe9hhXHzqneHyhdcCJyxdCL4HY24QORGJJgFOoxjuZDFYXM_H0h16hVWCovAW63JOztGRs9YYr4crPh6_nMh7tzK3x6mM6C8vsm6r9_1pW78NMYMfUr7HaeGwwhhEhsyJDMuTYMboLGs0-CYP2T85Fnb1AId11jPc7omr9YqA08CGJwPXalfsmmcV4LJVmeAyGr8H_XAEXPGEzZdJDIwDKThSmvJWNWZalrKISRVcuxEKF74zOct8qNnj6AqszX1N1ExLTgLWwBUJhVZuBVcoRy2T7Mg9-Q5J95MjDPlKm7WtPxBjpUrNinWz1tS67k60D9vNiJEEGzLVy-RpZ0xnifyX1qAfBGg5owVvD69QAfDZ4yrTZrzBVXUyWPTczu94w0Qv5RsgdH3jvpy4ph7lo3ZrEsNZintLtIimsyZLB2UHVghjn7idhKJnHhZEpAjweM1YwUHW7UHiZSecgEk_2B0YkOo5N4t_cUVaYqK0v4idYveEYx30uLRiD-VPmK1XmseMN88-rucxQIdhEoGGeGpmwUpZik0zFFBfZ8xiaKJXlYY0e96v4JVTB2tAr8K-_wVvMRCnefCCw=w1418-h1414?auditContext=prefetch',
  ogType: 'website',
  date: '2025-07-07',
  tag1: '#IPS',
  tag2: '#IndoorPositioningSystem',
  tag3: '#실내위치추적시스템',
  tag4: '#기업을위한IPS솔루션',
  text: [
    {
      head: '',
      subHead: '',
      desc: '4차 산업혁명 시대에 IPS(Indoor Positioning System), 즉 실내 위치 추적 시스템은 기업과 조직이 밀폐된 공간 내에서 사람, 장비, 자산의 위치를 제어하는 데 핵심적인 솔루션으로 자리 잡았습니다. GPS가 실외에서만 작동하는 것과 달리, IPS는 Wi-Fi, BLE, UWB, RFID와 같은 기술을 활용해 공장, 쇼핑몰, 공항 등 복잡한 실내 환경에서 정확한 위치를 추적합니다. 이 글에서는 IPS가 무엇인지, 주요 기술, 이점, 그리고 디지털 전환에서의 역할을 자세히 알아보겠습니다.',
      dot: ''
    },
    {
      head: 'IPS란 무엇인가?',
      subHead: '',
      desc: 'Indoor Positioning System(IPS), 즉 실내 위치 추적 시스템은 실내 환경에서 높은 정확도(보통 수십 cm에서 수 m)로 위치를 확인하는 시스템입니다. IPS는 다음 요소들로 구성됩니다.\n\n태그/비콘(Tags/Beacons): 추적 대상에 부착된 신호 발신 장치입니다.\n\n앵커/수신기(Anchors/Receivers): 고정된 신호 수신/발신 지점으로, 전체 영역에 설치됩니다.\n\n처리 소프트웨어: 신호 강도, 전송 시간, 다중 측위(multilateration) 알고리즘을 기반으로 좌표를 계산합니다',
      dot: ''
    },
    {
      head: 'IPS의 주요 기술',
      subHead: '',
      desc: 'BLE(Bluetooth Low Energy)\n장점: 저렴한 비용, 낮은 에너지 소비, 기존 블루투스 인프라에 쉽게 배치 가능\n단점: 정확도 약 1–3 m\n\nUWB(Ultra-Wideband)\n장점: 높은 정확도(±10–30 cm), 간섭에 강함\n단점: 높은 투자 비용, 전용 하드웨어 필요\n\nWi-Fi RTT(Round-Trip Time)\n장점: 기존 Wi-Fi 인프라 활용, 정확도 약 1–2 m\n단점: AP 품질과 설정에 의존\n\nRFID\n장점: 고정된 판독 영역 설정, 수동 태그의 저렴한 비용\n단점: 짧은 범위, 판독 게이트를 통과할 때만 식별 가능\n\n카메라 비전(Camera Vision)\n장점: 이미지 인식 결합, 태그 부착 불필요\n단점: 높은 비용, 이미지 처리의 복잡성',
      dot: ''
    },
    {
      head: '기술에서 IPS의 역할',
      subHead: '',
      desc: '자산 및 장비 관리\n실시간 추적: 공장 내 지게차, 팔레트, 병원 내 의료 장비의 위치를 확인\n프로세스 최적화: 물품을 찾는 시간을 줄이고 운영 생산성을 높임\n\n보안 및 안전 개선\n인력 감시: 위험 지역에 들어간 직원을 추적하고, 금지 구역 침입 시 경고\n긴급 구조: 공장이나 고층 건물에서 사고 발생 시 피해자의 위치를 신속히 확인\n\n고객 경험 최적화\n쇼핑몰 내 안내: 모바일 앱으로 상점, 화장실, 서비스 데스크로 가는 길을 안내\n스마트 관광: 공항, 박물관에서 길 안내 제공\n\n데이터 분석 및 프로세스 개선\n행동 히트맵: 사람이 많이 모이는 지점을 파악해 매장 배치나 좌석을 최적화\n유동량 예측: AI가 혼잡 지역을 예측해 인력과 자원을 배치',
      dot: ''
    },
    {
      head: 'IPS 구축의 이점',
      subHead: '',
      desc: '높은 정확도: 위치 추적 오차가 수십 cm에 불과합니다.\n\n비용 절감: 물품을 찾는 데 드는 시간과 인력을 줄입니다.\n\n안전성 향상: 위험 상황에 대한 적시 경고 제공합니다.\n\n경험 최적화: 고객과 직원을 위한 원활한 여정 제공.\n\n데이터 기반 통찰: 보고서와 분석을 통해 신속한 의사 결정 지원합니다.',
      dot: ''
    },
    {
      head: '결론',
      subHead: '',
      desc: 'IPS는 복잡한 실내 환경에서 필수적인 위치 추적 인프라로 자리 잡았습니다. BLE, UWB, Wi-Fi RTT, RFID와 같은 기술을 활용함으로써 기업은 자산 관리, 안전성 향상, 경험 최적화, 데이터 기반 의사 결정을 실현할 수 있습니다. 기업을 위한 IPS 솔루션에 투자하는 것은 기술 트렌드를 선도하고 지속 가능한 발전을 위한 전략적 선택입니다.',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/enterprise/manufacturing/steel',
      },
    ],
  },
};
